import { PATH_MESSAGES } from 'app/router/routesConfigMessages';

export function messages({ flags, path }) {
  if (PATH_MESSAGES === path) {
    return flags?.showMessagesGlobal;
  }

  return true;
}
